import React, { useEffect, useLayoutEffect } from 'react';
import { REDIRECT_URL } from '../../../../../app/shared/util/url-utils';
import { useLocation, useNavigate } from 'react-router';

export const LoginRedirect = () => {
  const pageLocation = useLocation();
  const navigate = useNavigate();
  useLayoutEffect(() => {
    const fromPath = pageLocation?.state?.from?.pathname;
    if (fromPath) {
      localStorage.setItem(REDIRECT_URL, fromPath);
      window.location.reload();
    } else {
      const redirectPath = localStorage.getItem(REDIRECT_URL) || '/';
      console.log(redirectPath, 'redirectPath--');
      navigate('/', { replace: true });
    }
  });

  return null;
};

export default LoginRedirect;
